import React, { useEffect, useState } from 'react';
import { projectsData, projectsNav } from './Data';
import WorkItems from './WorkItems';

// Component containing filters and projects
const Works = () => {
    // State to store the selected item
    const [item, setItem] = useState({ name: 'all' });
    // State to store the projects to display
    const [projects, setProjects] = useState([]);
    // State to store the index of the active item
    const [active, setActive] = useState(0);

    // Effect to filter projects based on the selected item
    useEffect(() => {
        if (item.name === "all") {
            setProjects(projectsData);
        } else {
            const newProjects = projectsData.filter((project) => {
                return project.category.toLowerCase() === item.name;
            });
            setProjects(newProjects);
        }
    }, [item]);

    // Handling click on a filter
    const handleClick = (e, index) => {
        setItem({ name: e.target.textContent.toLowerCase() });
        setActive(index);
    }

    return (
        <div>
            {/* Filters */}
            <div className="work__filters">
                {projectsNav.map((item, index) => {
                    return <span
                        onClick={(e) => { handleClick(e, index); }}
                        className={`${active === index ? 'active-work' : ''} work__item`}
                        key={index}>{item.name}</span>;
                })}
            </div>
            {/* Projects */}
            <div className="work__container container grid">
                {projects.map((item) => {
                    return <WorkItems item={item} key={item.id} />
                })}
            </div>
        </div>
    )
}

export default Works;
